import { FormattedMessage, useIntl } from 'react-intl';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CanceledIcon from '@mui/icons-material/Cancel';
import { red } from '@mui/material/colors';

import messages from './messages';
import styles from './styles.module.css';
import InformationalSection from '~/components/InformationalSection';

type CancelationCardProps = {
  reason?: string;
};

export const CancellationCard = (props: CancelationCardProps) => {
  const intl = useIntl();
  return (
    <InformationalSection
      title={
        <span style={{ color: red[900] }}>
          <FormattedMessage {...messages.turnCanceled} />
        </span>
      }
    >
      <ListItem>
        <ListItemIcon>
          <CanceledIcon style={{ color: red[300] }} />
        </ListItemIcon>
        <List>
          <ListItemText
            primary={
              <div className={styles['cancellation-card-reason']}>
                {props.reason
                  ? props.reason
                  : intl.formatMessage(messages.turnCanceledNoReason)}
              </div>
            }
          />
        </List>
      </ListItem>
    </InformationalSection>
  );
};

export default CancellationCard;
